module.exports = __webpack_public_path__ + "img/LogoWhitecarrot_Color.46326eb2.png";